<template>
  <el-card shadow="hover" class="card">
    <div class="header" @click.self="toggleCollapse">
      <div class="pointer" @click="toggleCollapse">
        <collapse-button :is-open="isOpen" />
        <span class="title">{{ title }}</span>
        <slot name="header" />
      </div>
      <div>
        <el-button
          v-if="action"
          type="text"
          @click="action.callback"
          :icon="action.icon"
          >{{ action.text }}</el-button
        >
      </div>
    </div>
    <div v-show="isOpen" class="content"><slot /></div>
  </el-card>
</template>

<script>
import CollapseButton from "@/components/CollapseButton";

export default {
  data() {
    return {
      isOpen: true,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    action: Object,
  },
  components: {
    CollapseButton,
  },
  methods: {
    toggleCollapse() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped>
.card {
  max-width: 1000px;
  margin: 10px auto;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
}
.title {
  font-weight: 600;
  text-transform: capitalize;
  margin-left: 10px;
}
.content {
  margin-top: 20px;
}
</style>
